import { useContext } from 'react';
import { CitrusFormContext } from '../react/private/CitrusFormContext';
/**
 * Hook to consume the CitrusForm context
 *
 * @returns {CitrusFormContextType}
 * @example
 * import { useCitrusForm } from '@citrus/form';
 * ...
 * const { form, dispatch, validate } = useCitrusForm();
 */
export var useCitrusForm = function () { return useContext(CitrusFormContext); };
